import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import AdminWebinars from "@/pages/AdminWebinars";
import AdminGate from "@/components/AdminGate";

export const Route = createFileRoute("/admin/webinars")({
  head: () => seoHead("/admin/webinars"),
  component: () => (
    <AdminGate><AdminWebinars /></AdminGate>
  ),
});
